import { CharlieSkeleton } from '@ver.id/libs.ui.charlie';

/** EmbeddedLoadingState — Three placeholder tiles while the apps load. */
export default function EmbeddedLoadingState({ label }: { label: string }) {
  return (
    <div role="status" aria-label={label} className="flex flex-col gap-2">
      {[0, 1, 2].map((i) => (
        <CharlieSkeleton key={i} className="h-[62px] rounded-[10px]" />
      ))}
    </div>
  );
}

/** The help-row placeholder that goes with the skeleton. */
export function EmbeddedLoadingStateHelp() {
  return (
    <span aria-hidden="true" className="h-3.5 w-28 rounded-full bg-muted" />
  );
}
